import React, { Component } from 'react';

export default class Testimonials extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="testimonials">
			<div className="text-container">
				<div className="row">
					<div className="two columns header-col">
						<h1><span>Client Testimonials</span></h1>
					</div>
					
					<div className="ten columns flex-container">
						<div className="flexslider">
							<ul className="slides">
								<li>
									<blockquote>
									<p>
									Here are some of my achievements in languages, frameworks and CMS
									</p>
							  
									<cite>Gabriele Cassano</cite>
									</blockquote>
								</li> 
								
								<li>
									<blockquote>
									<p>
									Music projects and projects that allowed me to acquire skills.
									</p>
									
									<cite>Mr. Adobe</cite>
									</blockquote>
								</li> 
							</ul>
						</div> 
					</div> 
				</div> 
			</div>  
		</section> 
	  }   
      </React.Fragment>
    );
  }
}
